import HomeHeader from '../../components/home/header/HomeHeader'
import SignUpPageComponent from '../../components/singup/SignUpPageComponent'
import HomeFooter from '../../components/home/footer/HomeFooter'
import './SignUpPage.css'

const SignUpPage = () => {
  return (
    <div>
      <div className='header-container'>
        <HomeHeader isHeaderLeft={true} showLoginButton={true} showSignupButton={true}/>
      </div>
      <div style={{ paddingTop: '70px', paddingBottom: '100px', marginBottom: '45px' }}>
        {/* put inside the founders page here */}
        <SignUpPageComponent/>
      </div>
      <div style={{ background: 'black', color: 'white' }}>
        <HomeFooter />
      </div>
    </div>
  );
}

export default SignUpPage;